import React from "react";

import DefaultTipDetails from "./DefaultTipDetails";
import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

class TipDetails extends React.Component<any> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <DefaultTipDetails />
      </Container>
    );
  }
}

export default TipDetails;
